import React, { FC } from 'react'
import './index.scss'

interface IProps {}

const MktLoading: FC<IProps> = (props) => {
  return (
    <div className='mkt-loading'>
      <img src={window.BASECONFIG.loadingGif} />
    </div>
  )
}

export default MktLoading
